// Copyright (c) 2019, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import PropTypes from 'prop-types'
import { parse, print } from 'graphql'

const syntaxHighlight = (json) => (
  json.replace(
    // eslint-disable-next-line no-useless-escape
    /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g,
    (match) => {
      let cls = 'number'
      if (/^"/.test(match)) {
          if (/:$/.test(match)) {
              cls = 'key'
          } else {
              cls = 'string'
          }
      } else if (/true|false/.test(match)) {
          cls = 'boolean'
      } else if (/null/.test(match)) {
          cls = 'null'
    }
    return '<span class='+ cls + '>' + match +'</span>'
  })
)

const makeReadable = (string) => (
  print(parse(string))
)

const EventRequest = ({ request, result }) => {
  let queryString = JSON.stringify(request.query)
    .replace(/"/g, '')  // remove double-quotes
    .replace(/\\n/g, '') // remove \n string literals

  let variableString = request.variables
    ? JSON.stringify(request.variables, null, 2)  // pretty-prints with 2 spaces (JSON.stringify(value[, replacer[, space]]))
    : null

  let requestString = makeReadable(queryString)

  return (
    <dl>
      <dd className='slds-item_label slds-text-align_center'>
        <b>Request</b>
      </dd>
      <dt
        className='slds-item_detail json-prettify key'
        dangerouslySetInnerHTML={{
          __html: requestString
        }}
      />
      {variableString &&
        <React.Fragment>
          <dd className='slds-item_label slds-text-align_center'>
            <b>Variables</b>
          </dd>
          <dt
            className='slds-item_detail json-prettify'
            dangerouslySetInnerHTML={{
              __html: syntaxHighlight(variableString)
            }}
          />
        </React.Fragment>
      }
      <dd className='slds-item_label slds-m-top_small slds-text-align_center'>
        <b>Result</b>
      </dd>
      <dt
        className='slds-item_detail json-prettify'
        dangerouslySetInnerHTML={{
          __html: syntaxHighlight(JSON.stringify(result.data, null, 2))
        }}
      />
    </dl>
  )
}

EventRequest.propTypes = {
  request: PropTypes.shape({
    query: PropTypes.object.isRequired
  }),
  result: PropTypes.shape({
    data: PropTypes.object.isRequired
  })
}

export default EventRequest



// WEBPACK FOOTER //
// ./src/components/whatsapp-message-event-details/EventRequest.js